/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Flex_DaysInputs */

const en_us2_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 free day`);
	return /** @type {LocalizedString} */ (`${i?.count} free days`)
	
};

const pt_br2_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia livre`);
	return /** @type {LocalizedString} */ (`${i?.count} dias livres`)
	
};

const es_419_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 día flexible`);
	return /** @type {LocalizedString} */ (`${i?.count} días flexibles`)
	
};

const pt_pt2_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia livre`);
	return /** @type {LocalizedString} */ (`${i?.count} dias livres`)
	
};

const fr_fr2_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 jour libre`);
	return /** @type {LocalizedString} */ (`${i?.count} jours libres`)
	
};

const de_de2_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 freier Tag`);
	return /** @type {LocalizedString} */ (`${i?.count} freie Tage`)
	
};

const it_it2_profile_flex_days = /** @type {(inputs: Profile_Flex_DaysInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 giorno libero`);
	return /** @type {LocalizedString} */ (`${i?.count} giorni liberi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 free day" |
* | * | "{count} free days" |
*
* @param {Profile_Flex_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_flex_days = /** @type {((inputs: Profile_Flex_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Flex_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_flex_days(inputs)
	if (locale === "es-419") return es_419_profile_flex_days(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_flex_days(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_flex_days(inputs)
	if (locale === "de-DE") return de_de2_profile_flex_days(inputs)
	if (locale === "it-IT") return it_it2_profile_flex_days(inputs)
	return en_us2_profile_flex_days(inputs)
});
export { profile_flex_days as "profile.flex_days" }